<template>
  <v-layout row wrap mb-0>
    <v-flex xs12 ml-2 pt-4 v-if="header">
      <div style="float: left; padding-left: 11px; margin-bottom: 0px">
        <h4 style="margin: 0px; color: blue" id="counter">{{ header }}</h4>
      </div>
    </v-flex>
    <v-flex xs12 ml-2 pt-3 v-if="sessionName">
      <div style="float: left; padding-left: 11px; padding-top: 0px">
        <p style="font-size: 13px; margin: 0px; font-weight: bold" id="counter">
          {{ sessionName }}
        </p>
      </div>
    </v-flex>
    <v-flex xs12 m-0 p-0>
      <v-data-table
        ref="dataTable"
        :items="accountList"
        class="elevation-1"
        :loading="showListLoading"
        hide-actions
        :headers="headers"
        item-key="parentAccountId"
        expand
        v-if="sessionName"
      >
        <template slot="items" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td style="width: calc(100% / 9); overflow: hidden">
              {{ props.item.parentAccountCode }}
            </td>
            <td style="width: calc(100% / 9); overflow: hidden">
              {{ props.item.parentAccountName }}
            </td>
            <td style="width: calc(100% / 9); overflow: hidden">
              {{ props.item.nature }}
            </td>
            <td
              style="width: calc(100% / 9); overflow: hidden; text-align: right"
            >
              <span v-if="props.item.isSubtract"
                >({{ props.item.totalBudget | decFormat }})</span
              >
              <span v-else>{{ props.item.totalBudget | decFormat }}</span>
            </td>
            <td
              style="width: calc(100% / 9); overflow: hidden; text-align: right"
            >
              <span v-if="calculatePercentage"
                >{{
                  baseBudget != 0
                    ? (props.item.totalBudget / baseBudget) * 100
                    : 0 | decFormat
                }}
                %</span
              >
            </td>
            <td
              v-for="(detail, index) in dynamicHeaderList"
              :key="index"
              style="width: calc(100% / 9); overflow: hidden; text-align: right"
            >
              {{
                getShopAmount(detail.id, props.item.totalLedgerByAmountList)
                  | decFormat
              }}
            </td>
            <td
              style="width: calc(100% / 9); overflow: hidden; text-align: right"
            >
              <span v-if="props.item.isSubtract"
                >({{ props.item.totalAmount | decFormat }})</span
              >
              <span v-else>{{ props.item.totalAmount | decFormat }}</span>
            </td>
            <td
              style="width: calc(100% / 9); overflow: hidden; text-align: right"
            >
              <span v-if="calculatePercentage"
                >{{
                  baseAmount != 0
                    ? (props.item.totalAmount / baseAmount) * 100
                    : 0 | decFormat
                }}
                %</span
              >
            </td>
            <td
              style="width: calc(100% / 9); overflow: hidden; text-align: right"
            >
              <span v-if="props.item.isSubtract"
                >({{
                  (props.item.totalAmount - props.item.totalBudget) | decFormat
                }})</span
              >
              <span v-else>{{
                (props.item.totalAmount - props.item.totalBudget) | decFormat
              }}</span>
            </td>
            <td
              style="width: calc(100% / 9); overflow: hidden; text-align: right"
            >
              <span v-if="calculatePercentage"
                >{{
                  baseAmount - baseBudget != 0
                    ? ((props.item.totalAmount - props.item.totalBudget) /
                        (baseAmount - baseBudget)) *
                      100
                    : 0 | decFormat
                }}
                %</span
              >
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-card class="elevation-1">
            <v-card-text>
              <v-data-table
                :items="props.item.incomeStatementDetailList"
                item-key="props.item.parentAccountId"
                hide-actions
                hide-headers
                class="elevation-10"
              >
                <template slot="items" slot-scope="subprops">
                  <tr>
                    <td style="width: 10%; overflow: hidden" class="text-xs">
                      {{ subprops.item.subAccountCode }}
                    </td>
                    <td style="width: 15%; overflow: hidden" class="text-xs">
                      {{ subprops.item.subAccountName }}
                    </td>
                    <td style="width: 5%; overflow: hidden" class="text-xs">
                      <span style="padding-left: 2em">{{
                        subprops.item.nature
                      }}</span>
                    </td>
                    <td
                      style="width: 15%; overflow: hidden; text-align: right"
                      class="text-xs"
                    >
                      <span>{{ subprops.item.budget | decFormat }}</span>
                    </td>
                    <td style="width: 5%; overflow: hidden; text-align: right">
                      <span v-if="calculatePercentage"
                        >{{
                          baseBudget != 0
                            ? (subprops.item.budget / baseBudget) * 100
                            : 0 | decFormat
                        }}
                        %</span
                      >
                    </td>
                    <td
                      v-for="(detail, index) in dynamicHeaderList"
                      :key="index"
                      style="width: calc(100% / 9); overflow: hidden; text-align: right"
                    >
                      {{
                        getShopAmount(
                          detail.id,
                          subprops.item.ledgerByAmountList
                        ) | decFormat
                      }}
                    </td>
                    <td
                      style="width: 15%; overflow: hidden; text-align: right"
                      class="text-xs"
                    >
                      <span>{{ subprops.item.amount | decFormat }}</span>
                    </td>
                    <td style="width: 5%; overflow: hidden; text-align: right">
                      <span v-if="calculatePercentage"
                        >{{
                          baseAmount != 0
                            ? (subprops.item.amount / baseAmount) * 100
                            : 0 | decFormat
                        }}
                        %</span
                      >
                    </td>
                    <td
                      style="width: 15%; overflow: hidden; text-align: right"
                      class="text-xs"
                    >
                      <span>{{
                        (subprops.item.amount - subprops.item.budget)
                          | decFormat
                      }}</span>
                    </td>
                    <td style="width: 5%; overflow: hidden; text-align: right">
                      <span v-if="calculatePercentage"
                        >{{
                          baseAmount - baseBudget != 0
                            ? ((subprops.item.amount - subprops.item.budget) /
                                (baseAmount - baseBudget)) *
                              100
                            : 0 | decFormat
                        }}
                        %</span
                      >
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </template>
        <template slot="footer">
          <td style="font-weight: bold" colspan="3">Total</td>
          <td style="font-weight: bold; text-align: right">
            {{ sessionTotalBudget | decFormat }}
          </td>
          <td style="font-weight: bold; text-align: right">
            {{
              baseAmount != 0
                ? (sessionTotalBudget / baseBudget) * 100
                : sessionName === "Revenue"
                ? 100
                : 0 | decFormat
            }}
            %
          </td>
          <td
            v-for="(detail, index) in dynamicHeaderList"
            :key="index"
            style="font-weight: bold; text-align: right"
          >
            {{ getShopAmount(detail.id, sessionAmountList) | decFormat }}
          </td>
          <td style="font-weight: bold; text-align: right">
            {{ sessionTotalAmount | decFormat }}
          </td>
          <td style="font-weight: bold; text-align: right">
            {{
              baseAmount != 0
                ? (sessionTotalAmount / baseAmount) * 100
                : sessionName === "Revenue"
                ? 100
                : 0 | decFormat
            }}
            %
          </td>
          <td style="font-weight: bold; text-align: right">
            {{ (sessionTotalAmount - sessionTotalBudget) | decFormat }}
          </td>
          <td style="font-weight: bold; text-align: right">
            {{
              baseAmount - baseBudget != 0
                ? ((sessionTotalAmount - sessionTotalBudget) /
                    (baseAmount - baseBudget)) *
                  100
                : sessionName === "Revenue"
                ? 100
                : 0 | decFormat
            }}
            %
          </td>
          <td></td>
        </template>
      </v-data-table>
      <div style="padding: 0px">
        <table
          :style="useBgColor ? `background: rgba(128, 128, 128, 0.5)` : ``"
          v-if="footer"
          style="width: 100%; border-collapse: collapse; margin: 0; height: 40px;"
        >
          <tbody>
            <tr
              style="
                  padding-right: 50px"
            >
              <td
                :style="{
                  ...getColumnStyle([0, 1, 2]),
                  'padding-left': '0px',
                  margin: '0px',
                }"
              >
                <div
                  style="float: left; padding-left: 11px; padding-right: 0px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ footer }}
                  </h4>
                </div>
              </td>
              <td
                :style="{
                  ...getColumnStyle([3]),
                  'padding-left': '0px',
                  margin: '0px',
                }"
              >
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ footerBudget | decFormat }}
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([4])">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{
                      baseBudget != 0
                        ? (footerBudget / baseBudget) * 100
                        : sessionName === "Revenue" ||
                          footer === "Production Cost of Good Completed"
                        ? 100
                        : 0 | decFormat
                    }}
                    %
                  </h4>
                </div>
              </td>
              <td
                v-for="(detail, index) in dynamicHeaderList"
                :key="index"
                :style="getColumnStyle([5 + index])"
              >
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ getShopAmount(detail.id, footerAmountList) | decFormat }}
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([5], true)">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ footerAmount | decFormat }}
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([6], true)">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{
                      baseAmount != 0
                        ? (footerAmount / baseAmount) * 100
                        : sessionName === "Revenue" ||
                          footer === "Production Cost of Good Completed"
                        ? 100
                        : 0 | decFormat
                    }}
                    %
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([7], true)">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ (footerAmount - footerBudget) | decFormat }}
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([8], true)">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{
                      baseAmount - baseBudget != 0
                        ? ((footerAmount - footerBudget) /
                            (baseAmount - baseBudget)) *
                          100
                        : sessionName === "Revenue" ||
                          footer === "Production Cost of Good Completed"
                        ? 100
                        : 0 | decFormat
                    }}
                    %
                  </h4>
                </div>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <table
          :style="
            footer2UseBgColor ? `background: rgba(128, 128, 128, 0.5)` : ``
          "
          v-if="footer2"
          style="width: 100%; border-collapse: collapse; margin: 0; height: 40px;"
        >
          <tbody>
            <tr
              style="
                  padding-right: 50px"
            >
              <td
                :style="{
                  ...getColumnStyle([0, 1, 2]),
                  'padding-left': '0px',
                  margin: '0px',
                }"
              >
                <div
                  style="float: left; padding-left: 11px; padding-right: 0px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ footer2 }}
                  </h4>
                </div>
              </td>
              <td
                :style="{
                  ...getColumnStyle([3]),
                  'padding-left': '0px',
                  margin: '0px',
                }"
              >
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ footer2Budget | decFormat }}
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([4])">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{
                      baseBudget != 0
                        ? (footer2Budget / baseBudget) * 100
                        : sessionName === "Revenue" ||
                          footer2 === "Production Cost of Good Completed"
                        ? 100
                        : 0 | decFormat
                    }}
                    %
                  </h4>
                </div>
              </td>
              <td
                v-for="(detail, index) in dynamicHeaderList"
                :key="index"
                :style="getColumnStyle([5 + index])"
              >
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ getShopAmount(detail.id, footer2AmountList) | decFormat }}
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([5], true)">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ footer2Amount | decFormat }}
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([6], true)">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{
                      baseAmount != 0
                        ? (footer2Amount / baseAmount) * 100
                        : sessionName === "Revenue" ||
                          footer2 === "Production Cost of Good Completed"
                        ? 100
                        : 0 | decFormat
                    }}
                    %
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([7], true)">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{ (footer2Amount - footer2Budget) | decFormat }}
                  </h4>
                </div>
              </td>
              <td :style="getColumnStyle([8], true)">
                <div
                  style="float: right; margin-right: 15px; padding-right: 13px;"
                >
                  <h4 style="font-weight: bold; margin: 0;" id="counter">
                    {{
                      baseAmount - baseBudget != 0
                        ? ((footer2Amount - footer2Budget) /
                            (baseAmount - baseBudget)) *
                          100
                        : sessionName === "Revenue" ||
                          footer2 === "Production Cost of Good Completed"
                        ? 100
                        : 0 | decFormat
                    }}
                    %
                  </h4>
                </div>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: [
    "header",
    "sessionName",
    "accountList",
    "calculatePercentage",
    "baseAmount",
    "sessionTotalAmount",
    "sessionAmountList",
    "baseBudget",
    "sessionTotalBudget",
    "showListLoading",
    "footer",
    "footerAmount",
    "footerAmountList",
    "footerBudget",
    "useBgColor",
    "footer2",
    "footer2Amount",
    "footer2AmountList",
    "footer2Budget",
    "footer2UseBgColor",
    "dynamicHeaderList",
  ],
  data: () => ({
    headers: [
      { text: "Account Code", sortable: false, width: "10%" },
      { text: "Account Name", sortable: false, width: "15%" },
      { text: "Nature", sortable: false, width: "5%" },
      { text: "Total Budget", sortable: false, width: "15%", align: "right" },
      { text: "Total Budget(%)", sortable: false, width: "5%", align: "right" },
      { text: "Amount", sortable: false, width: "15%", align: "right" },
      { text: "Amount(%)", sortable: false, width: "5%", align: "right" },
      {
        text: "Difference Budget",
        sortable: false,
        width: "15%",
        align: "right",
      },
      {
        text: "Difference Budget(%)",
        sortable: false,
        width: "5%",
        align: "right",
      },
    ],
    headersClone: [
      { text: "Account Code", sortable: false, width: "10%" },
      { text: "Account Name", sortable: false, width: "15%" },
      { text: "Nature", sortable: false, width: "5%" },
      { text: "Total Budget", sortable: false, width: "15%", align: "right" },
      { text: "Total Budget(%)", sortable: false, width: "5%", align: "right" },
      { text: "Amount", sortable: false, width: "15%", align: "right" },
      { text: "Amount(%)", sortable: false, width: "5%", align: "right" },
      {
        text: "Difference Budget",
        sortable: false,
        width: "15%",
        align: "right",
      },
      {
        text: "Difference Budget(%)",
        sortable: false,
        width: "5%",
        align: "right",
      },
    ],
    columnWidths: [],
  }),
  mounted() {
    if (this.dynamicHeaderList) {
      this.updateHeader();
    }
    this.updateColumnWidths();
  },
  watch: {
    accountList: {
      handler() {
        if (this.dynamicHeaderList) {
          this.updateHeader();
        }
        this.updateColumnWidths();
      },
      deep: true, // Ensures nested changes are watched
    },
  },
  methods: {
    updateColumnWidths() {
      this.$nextTick(() => {
        // Wait until DOM updates
        const dataTable = this.$refs.dataTable;
        if (dataTable) {
          const headers = dataTable.$el.querySelectorAll("thead th");
          this.columnWidths = Array.from(headers).map(
            (header) => header.offsetWidth
          );
        }
      });
    },
    getColumnStyle(indexList, isAfterDynamic) {
      // Apply width style only if it's defined in columnWidths
      let list = [];
      if (indexList) {
        list = indexList;
      }
      let totalWidth = list.reduce((sum, index) => {
        let idx = index;
        if (this.dynamicHeaderList && isAfterDynamic) {
          idx = Number(idx) + Number(this.dynamicHeaderList.length);
        }
        const width = this.columnWidths[idx];
        return sum + (width ? Number(width) : 0);
      }, 0);
      return { width: totalWidth + "px" };
    },

    updateHeader() {
      // Apply width style only if it's defined in columnWidths
      if (this.dynamicHeaderList) {
        this.headers = JSON.parse(JSON.stringify(this.headersClone));
        this.headers.splice(
          5,
          0,
          ...this.dynamicHeaderList.map((v) => {
            return {
              text: v.name,
              value: v.id,
              sortable: false,
              align: "right",
            };
          })
        );
      }
    },
    getShopAmount(id, item) {
      let amount = 0;
      if (item) {
        let element = item.find((p) => p.ledgerById === id);
        if (element) {
          amount = element.ledgerByAmount;
        }
      }
      return amount;
    },
  },
};
</script>
